import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ButtonComponent } from '@modules/components/button/button.component';
import { SearchFieldComponent } from '@modules/components/search-field/search-field.component';
import { loadTable } from '@utils/load-users-table';
import { UsersListComponent } from '../companies/components/users-list/users-list.component';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-admins',
  imports: [ReactiveFormsModule, MatIconModule, MatToolbarModule, ButtonComponent, SearchFieldComponent],
  templateUrl: './application-admins.component.html',
  styleUrls: ['./application-admins.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminsComponent extends UsersListComponent implements OnInit, OnDestroy {
  private cdr = inject(ChangeDetectorRef);

  @ViewChild('table', { static: true, read: ViewContainerRef })
  private table: ViewContainerRef | undefined;

  ngOnInit(): void {
    this.loadTable();
  }

  private loadTable = async (): Promise<void> => {
    if (this.table) {
      await loadTable({
        table: this.table,
      });
    }

    this.cdr.markForCheck();
  };
}
